
const digest = '035a2b7237dafa668b40bad983aaa6b2360751726cfca9f9b70c03f30cff8e12';
const classes = {"wrapper":"_wrapper_gidn0_1","content":"_content_gidn0_13","title":"_title_gidn0_16","subTitle":"_subTitle_gidn0_20","controls":"_controls_gidn0_24"};
const css = `._wrapper_gidn0_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 18px 19px;
  gap: 28px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_gidn0_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_gidn0_1 ._content_gidn0_13 {
  flex-grow: 1;
}
._wrapper_gidn0_1 ._content_gidn0_13 ._title_gidn0_16 {
  color: #000000;
  font-weight: 500;
}
._wrapper_gidn0_1 ._content_gidn0_13 ._subTitle_gidn0_20 {
  color: #000000;
  font-size: 14px;
}
._wrapper_gidn0_1 ._controls_gidn0_24 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  